import React, { useEffect, useState } from 'react';
import QuillCo from '../CreatePost/Quill/QuillCo';
import { Navigate, useParams } from 'react-router-dom';
import './EditPost.css';
import { SectionWrap } from '../../Components';
import LoadingPage from '../LoadingPage/LoadingPage';

function EditPost() {
    // const apiUrl = 'http://localhost/server/testServer/post.php';
    const apiUrl = 'https://www.albarede.com/server/post.php';
    const { id } = useParams();
    const [title, setTitle] = useState('');
    const [summary, setSummary] = useState('');
    const [content, setContent] = useState('');
    const [tags, setTags] = useState(''); // <--- حالة جديدة للوسوم
    const [redirect, setRedirect] = useState(false);
    const [isLoading, setIsLoading] = useState(true); // حالة التحميل
    
    // Fetch existing post data
    useEffect(() => {
        setIsLoading(true);
        fetch(`${apiUrl}?id=${id}`)
            .then((response) => response.json())
            .then((data) => {
                setTitle(data.title || '');
                setSummary(data.summary || '');
                setContent(data.content || '');
                setTags(data.tags || ''); // <--- جلب الوسوم الموجودة
                setIsLoading(false);
            })
            .catch((err) => {
                console.error('Error fetching post:', err);
                setIsLoading(false); // توقف التحميل حتى في حالة الخطأ
            });
    }, [id]);

    // Update post function
    const updatePost = async (ev) => {
        ev.preventDefault();

        if (!title || !summary || !content) {
            alert('الرجاء ملء جميع الحقول المطلوبة (العنوان، الملخص، المحتوى).');
            return;
        }

        const postData = {
            title,
            summary,
            content,
            tags, // <--- تضمين الوسوم في البيانات المرسلة
        };

        try {
            const response = await fetch(`${apiUrl}?id=${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(postData),
            });

            if (!response.ok) {
                const error = await response.json();
                alert(`خطأ: ${error.error || 'حدث خطأ غير متوقع'}`);
                return;
            }

            alert('تم تعديل المقال بنجاح');
            setRedirect(true);
        } catch (err) {
            console.error('Error updating post:', err);
            alert('فشل تحديث المقال. يرجى المحاولة لاحقاً.');
        }
    };

    // Delete post function (بدون تغيير)
    const deletePost = async () => {
        const confirmDelete = window.confirm('هل أنت متأكد أنك تريد حذف هذا المقال؟');
        if (!confirmDelete) return;

        try {
            const response = await fetch(`${apiUrl}?id=${id}`, {
                method: 'DELETE',
            });

            if (!response.ok) {
                const error = await response.json();
                alert(`خطأ: ${error.error || 'فشل حذف المقال'}`);
                return;
            }

            alert('تم حذف المقال بنجاح');
            setRedirect(true);
        } catch (err) {
            console.error('Error deleting post:', err);
        }
    };

    if (redirect) {
        return <Navigate to="/articles" />;
    }
    if (isLoading) {
        return <LoadingPage />; // عرض صفحة التحميل أثناء التحميل
    }

    return (
        <div className="editPage">
            <SectionWrap>
                <form onSubmit={updatePost}>
                    <h1>تعديل المقالة</h1>
                    <input
                        type="text"
                        placeholder="العنوان"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                    <textarea
                        placeholder="الملخص"
                        value={summary}
                        onChange={(e) => setSummary(e.target.value)}
                    />
                    <label>نص المقال</label>
                    <QuillCo
                        onTextChange={(newContent) => setContent(newContent)}
                        defaultContent={content || ''}
                    />
                    {/* <--- حقل إدخال الوسوم الجديد ---> */}
                    <label>الوسوم (مفصولة بفاصلة)</label>
                    <input
                        type="text"
                        placeholder="أضف وسوماً (مثال: مدني, جزائي, طلاق)"
                        value={tags}
                        onChange={(e) => setTags(e.target.value)}
                    />
                    {/* <--- نهاية حقل الوسوم ---> */}

                    <button type="submit" className="postBtn">حفظ التعديلات</button>
                    <button
                        type="button"
                        onClick={deletePost}
                        className="postBtnDelet"
                    >
                        حذف المقالة
                    </button>
                </form>
            </SectionWrap>
        </div>
    );
}

export default EditPost;